import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ClientNextEngineLinkSimple } from "api/sms-api";
import { CRUDState, initialCRUDState } from "store/CRUDStore";

export interface EcSettingsState extends CRUDState<ClientNextEngineLinkSimple> {
  clientNextEngineLinks: Array<ClientNextEngineLinkSimple>;
  clientNextEngineLinksLoading: boolean;
  clientNextEngineLinksDeleting: boolean;
  clientNextEngineShippedOrdersCreating: boolean;
}

const initialState: EcSettingsState = {
  ...initialCRUDState,
  clientNextEngineLinksLoading: false,
  clientNextEngineLinksDeleting: false,
  clientNextEngineShippedOrdersCreating: false,
  clientNextEngineLinks: [],
};

export const slice = createSlice({
  name: "ecSettings",
  initialState,
  reducers: {
    getClientNextEngineLinksError: (state: any, action: PayloadAction<any>) => {
      state.error = action.payload;
      state.clientNextEngineLinksLoading = false;
    },
    getClientNextEngineLinksStart: (state: any) => {
      state.clientNextEngineLinksLoading = true;
    },
    getClientNextEngineLinksSuccess: (
      state: any,
      action: PayloadAction<Array<ClientNextEngineLinkSimple>>
    ) => {
      state.clientNextEngineLinks = action.payload;
      state.clientNextEngineLinksLoading = false;
    },
    deleteClientNextEngineLinkError: (
      state: any,
      action: PayloadAction<any>
    ) => {
      state.error = action.payload;
      state.clientNextEngineLinksDeleting = false;
    },
    deleteClientNextEngineLinkStart: (state: any) => {
      state.clientNextEngineLinksDeleting = true;
    },
    deleteClientNextEngineLinkSuccess: (state: any) => {
      state.clientNextEngineLinksDeleting = false;
    },
    createClientNextEngineShippedOrdersError: (
      state: any,
      action: PayloadAction<any>
    ) => {
      state.error = action.payload;
      state.clientNextEngineShippedOrdersCreating = false;
    },
    createClientNextEngineShippedOrdersStart: (state: any) => {
      state.clientNextEngineShippedOrdersCreating = true;
    },
    createClientNextEngineShippedOrdersSuccess: (state: any) => {
      state.clientNextEngineShippedOrdersCreating = false;
    },
  },
});

export const {
  getClientNextEngineLinksStart,
  getClientNextEngineLinksSuccess,
  getClientNextEngineLinksError,
  deleteClientNextEngineLinkStart,
  deleteClientNextEngineLinkSuccess,
  deleteClientNextEngineLinkError,
  createClientNextEngineShippedOrdersStart,
  createClientNextEngineShippedOrdersSuccess,
  createClientNextEngineShippedOrdersError,
} = slice.actions;

export default slice.reducer;
